// Network counts for the home page: GET /rail/counts (claims; vouches that are
// not standing anchors; standing anchors), and registered issuers. Never hard-coded.
import { api } from "../api/client";

export interface Counts { claims: number; vouches: number; anchors: number; issuers: number }

export async function fetchCounts(): Promise<Counts> {
  const r = await api.GET("/rail/counts");
  if (!r.data) throw new Error("counts are unavailable");
  return { claims: r.data.claims, vouches: r.data.vouches, anchors: r.data.anchors,
           issuers: r.data.registered_issuers + r.data.light_issuers };
}
